import { useEffect, useState } from 'react';
import useCmsApi from './api/useCmsApi';
import { useAuthorizationManager } from './authorization';
import { trackAppInsightsEvent } from '@src/initAppInsights';
import { isValidTenantBulletDefaults } from '@src/web-stories-wp/story-editor/src/elements/text/utils/tenantBulletDefaults';

export default function useTenantBulletDefaults() {
  const { studioBulletDefaultsApi } = useCmsApi();
  const { authContext } = useAuthorizationManager();
  const tenantName = authContext.tenant?.name;
  const [result, setResult] = useState(null);

  useEffect(() => {
    let active = true;
    const controller = new AbortController();
    const settle = (defaults) => {
      if (active)
        setResult({ tenantName, api: studioBulletDefaultsApi, defaults });
    };
    if (!tenantName) {
      settle(null);
      return () => {
        active = false;
      };
    }
    studioBulletDefaultsApi
      .get(controller.signal)
      .then((defaults) => {
        if (!active) return;
        if (defaults != null && !isValidTenantBulletDefaults(defaults)) {
          throw new Error('Invalid bullet defaults');
        }
        settle(defaults);
      })
      .catch(() => {
        if (!active) return;
        settle(null);
        // Send a fixed diagnostic, never the request error, URL or tenant payload.
        trackAppInsightsEvent('Studio: Bullet Defaults Unavailable');
      });
    return () => {
      active = false;
      controller.abort();
    };
  }, [tenantName, studioBulletDefaultsApi]);

  const isReady =
    result?.tenantName === tenantName &&
    result?.api === studioBulletDefaultsApi;
  return { isReady, defaults: isReady ? result.defaults : null };
}
